import { shuffle } from '../common/util.es6';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
// import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(MorphSVGPlugin);

export default class Top {
    constructor() {
        this.init();
    }

    init() {
        this.startAnimation();
        this.mvAnimation();
    }

    startAnimation() {
        // スクロール位置をリセット
        gsap.to(window, { duration: 0.3, scrollTo: 0 });

        // 初期位置
        gsap.set('body', { overflow: 'hidden' });
        gsap.set('.top__mainvisual__img__cont .cloud', { scale: 0 });
        gsap.set('.top__mainvisual__img__cont .logo', { scale: 0.9, opacity: 0 });
        gsap.set('.top__mainvisual__img__cont .shadow', { scale: 0.8, opacity: 0 });
        gsap.set('.top__mainvisual__img', { scale: 0.8, opacity: 0 });
        gsap.set('.l-header, .l-gnav__trigger, .top__mainvisual__scroll', { opacity: 0 });

        const tl = gsap.timeline();

        tl.to('.top__mainvisual__img__cont .cloud', { duration: 2, scale: 1, ease: 'elastic.out(1,0.5)' }, 0);
        tl.to('.top__mainvisual__img__cont .cloud', { duration: 0.6, opacity: 0, ease: 'power3.in' }, '<3');
        tl.to(
            '.top__mainvisual__img__cont .logo, .top__mainvisual__img__cont .shadow',
            {
                // duration: 4.0,
                duration: 3.0,
                scale: 1,
                opacity: 1,
                ease: 'elastic.out(1, 0.5)',
                onComplete: () => {
                    const logo = document.querySelector('.top__mainvisual__img__cont .logo');
                    logo.classList.add('-moving');
                },
            },
            '<'
        );
        // tl.to('.top__bg', { duration: 0.6, opacity: 0, ease: 'power2.inOut' }, '<2.0');
        tl.to('.top__mainvisual__img', { duration: 2.0, scale: 1, opacity: 1, ease: 'elastic.out(1,0.5)', stagger: 0.1 }, '+=0');
        tl.to('.l-header, .l-gnav__trigger, .top__mainvisual__scroll', { duration: 0.6, opacity: 1 }, '<1.2');
        tl.to('.top__mainvisual__skip', { duration: 0.6, opacity: 0, display: 'none' }, '<');
        tl.to('body', { overflow: 'auto' }, '+=0');
        tl.call(this.createScrollAnimations);

        // js-introskip ボタンが押されたときの処理
        document.querySelector('.js-introskip').addEventListener('click', (elm) => {
            tl.progress(1); // タイムラインを一気に終了状態に持っていく
            elm.currentTarget.classList.add('-hide');
        });
    }

    mvAnimation() {
        // 画像要素のリストを取得
        const imgs = [...document.querySelectorAll('.top__mainvisual__img')];

        const setActiveFunc = () => {
            const shuffledImgs = shuffle(imgs);
            const imgCount = shuffledImgs.length;
            let currentActiveIndex = 0;

            const activateNextImage = () => {
                shuffledImgs[currentActiveIndex].classList.add('-active');
                gsap.to(shuffledImgs[currentActiveIndex], { duration: 0.3, scale: 1.1, ease: 'power2.inOut' });

                setTimeout(() => {
                    shuffledImgs[currentActiveIndex].classList.remove('-active');
                    gsap.to(shuffledImgs[currentActiveIndex], { duration: 0.3, scale: 1.0, ease: 'power2.inOut' });
                    currentActiveIndex = (currentActiveIndex + 1) % imgCount;

                    setTimeout(activateNextImage, 3000);
                }, 4000);
            };

            activateNextImage();
        };

        // 全体の開始を10秒遅延させる
        setTimeout(() => setActiveFunc(), 10000);
    }

    createScrollAnimations() {
        const _this = this;
        const secTxt = document.querySelectorAll('.top__sec__txt'); // 複数の要素を取得

        secTxt.forEach((elm) => {
            const tl = gsap.timeline({
                paused: true,
            });

            const mySplitText = new SplitText(elm, { type: 'lines' });
            const lines = mySplitText.lines;

            gsap.set(lines, { opacity: 0, yPercent: 50 }); // デフォルトで非表示に

            tl.fromTo(
                lines,
                { opacity: 0, yPercent: 50 },
                {
                    opacity: 1,
                    yPercent: 0,
                    duration: 0.8,
                    ease: 'power2.out',
                    stagger: 0.1,
                }
            );

            ScrollTrigger.create({
                trigger: elm,
                start: 'top 80%',
                onEnter: () => {
                    elm.classList.add('-scrollin');
                    tl.play();
                },
                // markers: true
            });
        });

        const secLink = document.querySelectorAll('.top__sec__link');

        const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

        const activeateWithInterval = (element, delay) => {
            setTimeout(() => {
                const activateRandomly = () => {
                    const activeTime = getRandomInt(500, 1000); // ランダムなアクティブ時間
                    const nextInterval = getRandomInt(3000, 5000); // ランダムなインターバル

                    element.classList.add('-active');
                    setTimeout(() => {
                        element.classList.remove('-active');
                    }, activeTime);

                    setTimeout(activateRandomly, nextInterval);
                };

                activateRandomly();
            }, delay);
        };

        secLink.forEach((elm, index) => {
            const chara1 = elm.querySelector('.chara1');
            const chara2 = elm.querySelector('.chara2');

            const tl = gsap.timeline({
                paused: true,
            });

            const ttl = elm.querySelectorAll('.ttl');
            const ttl_popup = elm.querySelectorAll('.ttl_popup');
            const chara = elm.querySelectorAll('.chara');
            const ja_r = elm.querySelector('.ja.-r');
            const ja_l = elm.querySelector('.ja.-l');

            gsap.set(ttl, { opacity: 0, yPercent: -50 });
            gsap.set(ttl_popup, { opacity: 0, scale: 0.8, yPercent: 50 });
            gsap.set(chara, { opacity: 0, scale: 0.8 });
            gsap.set(ja_r, { opacity: 0, rotate: 30, transformOrigin: '40% 60%' });
            gsap.set(ja_l, { opacity: 0, rotate: -30, transformOrigin: '60% 60%' });

            tl.to(chara, { duration: 0.3, opacity: 1, scale: 1, stagger: 0.2, ease: 'back.out(3.0)', transformOrigin: 'bottom' }, 0.2);

            // 途中で分岐
            if (index !== 2) {
                tl.to(ttl, { duration: 0.6, yPercent: 0, opacity: 1, stagger: 0.2, ease: 'power2.in' }, '<0.2');
                tl.to(chara, { duration: 0.3, scaleX: 1.1, scaleY: 0.95, stagger: 0.2, ease: 'back.out(3.0)' }, '<0.6');
                tl.to(chara, { duration: 0.3, scaleX: 1, scaleY: 1, stagger: 0.2, ease: 'back.out(3.0)' }, '+=0');
                tl.to(ja_r, { duration: 0.8, opacity: 1, rotate: 0, ease: 'power2.inOut' }, '<');
                tl.to(ja_l, { duration: 0.8, opacity: 1, rotate: 0, ease: 'power2.inOut' }, '<');
                tl.call(activeateWithInterval, [chara1, 1000]);
                tl.call(activeateWithInterval, [chara2, 1500]);
            } else {
                tl.to(ttl_popup, { duration: 0.6, yPercent: 0, scale: 1, opacity: 1, stagger: 0.1, ease: 'back.out(3.0)' }, '<');
                tl.to(ja_r, { duration: 0.8, opacity: 1, rotate: 0, ease: 'power2.inOut' }, '<0.6');
                tl.to(ja_l, { duration: 0.8, opacity: 1, rotate: 0, ease: 'power2.inOut' }, '<');
            }

            ScrollTrigger.create({
                trigger: elm,
                start: 'top 80%',
                onEnter: () => {
                    elm.classList.add('-scrollin');
                    tl.play();
                },
                // markers: true
            });
        });
    }
}
